import React, { useEffect, useState, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';
import { Mail, Calendar } from 'lucide-react';

export default function AdminAppLeads() {
  const { apiClient } = useAuth();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLeads = useCallback(async () => {
    try { const { data } = await apiClient.get('/api/admin/app-leads'); setLeads(data); }
    catch { toast.error('Failed to load'); }
    finally { setLoading(false); }
  }, [apiClient]);

  useEffect(() => { fetchLeads(); }, [fetchLeads]);

  return (
    <div data-testid="admin-app-leads-page">
      <div className="mb-8">
        <h1 className="text-2xl font-heading font-bold text-white">IFEELINCOLOR App Leads</h1>
        <p className="text-white/50 text-sm">{leads.length} interested users</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-white/40" /></div>
      ) : leads.length === 0 ? (
        <div className="text-center py-16 text-white/40">No app leads yet</div>
      ) : (
        <div className="overflow-x-auto rounded-2xl border border-white/8">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-white/8">
                <th className="text-left text-white/40 font-medium p-4">Email</th>
                <th className="text-left text-white/40 font-medium p-4">Name</th>
                <th className="text-left text-white/40 font-medium p-4">Phone</th>
                <th className="text-left text-white/40 font-medium p-4">Date</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((l) => (
                <tr key={l.id} className="border-b border-white/5 hover:bg-white/3 transition-colors" data-testid={`admin-lead-${l.id}`}>
                  <td className="p-4 text-white font-semibold flex items-center gap-2"><Mail size={14} className="text-pink-400" /> {l.email}</td>
                  <td className="p-4 text-white/60">{l.name || '—'}</td>
                  <td className="p-4 text-white/60">{l.phone || '—'}</td>
                  <td className="p-4 text-white/40 flex items-center gap-1"><Calendar size={12} /> {new Date(l.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
